export const mdiSortReverseVariant = 'M3 11H15V13H3M3 18V16H21V18M3 6H9V8H3Z';

